import { api, apitest } from '../api.request';

//样品开发进度节点
const get1 = function(o) {
    return api.get("/production_schedule/get1", o)
}

const newProgress = function(o) {
    return apitest.get("/newProgress/newProgress", o)
}

export default {
    newProgress,
    get1,
}